export function isEmailLike(value: string): boolean {
    return /^[^@]+@[^.@]+\.[^.@]+[^@]*$/.test(value);
}
